import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const ServicesGroupsService = {
  async getAllGroups() {
    let response = await $axios.get($api("services_groups")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addGroupName(payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("services_groups"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateGroupName(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("services_groups_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteGroup(id: string) {
    let { data, status } = await $axios
      .delete($api("services_groups_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
